export enum Policies {
  CopyTaskLink = "Allow to see action to Copy task's link",
  SeeCallTarget = 'Allow to see call target for in-progress calls',
  SeeCallTargetWorkstation = 'Allow to see targeted workstation',
  SeeChannelName = 'Allow to see channel name',
  SeeAllTasks = 'Allow to see all tasks',
  SendTextMessage = 'send text message',
}
